import React from "react";
import { useParams } from "react-router-dom";
import ProjectDetails from "./ProjectDetails";
import projectData from "./projectData";
import { useLanguage } from "../../contexts/LanguageContext";
import { getTranslation } from "../../translations/translations";
import { getProjectDetail } from "../../translations/projectDetails";

function ProjectDetailPage() {
  const { path } = useParams();
  const { language } = useLanguage();
  const project = projectData.find((p) => p.path === path);

  if (!project) {
    return (
      <div style={{ padding: "100px 20px", textAlign: "center" }}>
        <h1>{getTranslation(language, "projectDetail.projectNotFound")}</h1>
        <p>{getTranslation(language, "projectDetail.projectNotFoundDesc")}</p>
      </div>
    );
  }

  // Get translations for role, problems, and solutions
  const translationKey = project.translationKey || project.path;
  const role = getProjectDetail(language, translationKey, "role");
  const problems = getProjectDetail(language, translationKey, "problems");
  const solutions = getProjectDetail(language, translationKey, "solutions");

  // Build left button (site link)
  const leftBtnText =
    project.siteLink && !project.offline ? (
      <a
        href={project.siteLink}
        alt="visitSite"
        target="_blank"
        rel="noreferrer"
      >
        {getTranslation(language, "projectDetail.visitSite")}
      </a>
    ) : null;

  // Build right button (GitHub link)
  const rightBtnText = project.GhLink ? (
    <a href={project.GhLink} alt="visitGH" target="_blank" rel="noreferrer">
      {getTranslation(language, "projectDetail.visitGitHub")}
    </a>
  ) : null;

  // Hide images for test projects
  const isTestProject = project.category === "tests";
  const images = isTestProject ? { img1: null, img2: null, img3: null } : {
    img1: project.img1,
    img2: project.img2,
    img3: project.img3,
  };

  return (
    <ProjectDetails
      title={project.detailTitle || `${project.title} |  `}
      leftBtnText={leftBtnText}
      rightBtnText={rightBtnText}
      role={role}
      problems={problems}
      solutions={solutions}
      img1={images.img1}
      img2={images.img2}
      img3={images.img3}
      icon1={project.icons?.[0]}
      icon2={project.icons?.[1]}
      icon3={project.icons?.[2]}
      icon4={project.icons?.[3]}
      icon5={project.icons?.[4]}
      icon6={project.icons?.[5]}
      offline={project.offline}
      extra={project.extra}
      hideImages={isTestProject}
    />
  );
}

export default ProjectDetailPage;
